import { extractDate } from 'components/Section/History/dateranges';
import { DateTime } from 'luxon';
/**
 * Figure the total amount of years to collect for the timeline
 */
export const totalYears = (birthdate, years = 10) => {
  let total = years;
  if (!birthdate) {
    return total;
  }

  const today = DateTime.local();
  const birthdateDate = DateTime.fromJSDate(birthdate);
  const eighteen = DateTime.fromObject({
    year: birthdateDate.year + 18,
    month: birthdateDate.month,
    day: birthdateDate.day,
  });

  total = Math.ceil(today.diff(eighteen, 'years').toObject().years);

  // Maximum years required
  if (total > years) {
    total = years;
  }

  // A minimum of two years is required
  if (total < 2) {
    total = 2;
  }

  return total;
};

/**
 * Default sorting of history objects. This assumes that all objects contain a `Dates` property
 * with date range values.
 */
export const sort = (a, b) => {
  // Helper to find the date value or default it to 0
  const getOptionalDate = (obj) => (((obj || {}).Item || {}).Dates || {}).to;

  const first = extractDate(getOptionalDate(a)) || 0;
  const second = extractDate(getOptionalDate(b)) || 0;

  if (a.type === 'Gap') {
    return 1;
  }

  if (b.type === 'Gap') {
    return -1;
  }

  if (first < second) {
    return 1;
  }

  if (first > second) {
    return -1;
  }

  return 0;
};
